import { on } from "@ngrx/store";
import { PermissionAddedAction, PermissionRemovedAction, PermissionUpdatedAction } from "./permisssion.actions";

export const permissionReducer = [
  on(PermissionAddedAction, (state: any, action) => {
    return Object.assign({}, state, { situazioneRuoli: {
        ruoli: state.situazioneRuoli.ruoli,
        permessi: [...state.situazioneRuoli.permessi, action.permission]
      }});
  }),

  on(PermissionRemovedAction, (state: any, action) => {
    return Object.assign({}, state, { situazioneRuoli: {
        ruoli: state.situazioneRuoli.ruoli,
        permessi: state.situazioneRuoli.permessi.filter(p => p.id_permesso !== +action.permissionId)
      }});
  }),

  on(PermissionUpdatedAction, (state: any, action) => {
    return Object.assign({}, state, { situazioneRuoli: {
        ruoli: state.situazioneRuoli.ruoli,
        permessi: state.situazioneRuoli.permessi.map(element => element.id_permesso === action.permission.id_permesso ? { ...element, id_permesso: action.permission.id_permesso, permesso: action.permission.permesso } : element)
      }});
  })
];
